import { ILoginPictureDto } from "../../../core/authentication/login-picture.dto";

export class LoginPictureModel {
  key: string;
  name: string;
  assetsPath: string;

  constructor(key: string, name: string, assetsPath: string = "") {
    this.key = key;
    this.name = name;
    this.assetsPath = assetsPath;
  }

  static fromDto(input: ILoginPictureDto, path: string): LoginPictureModel {
    return new LoginPictureModel(input.Key, input.Name, path);
  }

  getImageUrl(): string {
    return this.assetsPath + "/Auth/" + this.name;
  }
}
